import ReactStrapTable from "components/reactStrapTable";
import { Field, Formik } from "formik";
import React, { act, useEffect, useState } from "react";
import HoverImage from "react-hover-image/build";
import ReactSelect from "react-select";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import { cellRendererCheck } from "utils/columns";
import { OverlayTrigger } from "react-bootstrap";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import Calendar from "assets/icon/calendar-icon.svg";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import ErrorBoundary from "components/ErrorBoundary";
import useAxios from "hooks/useAxios";
import { setSelectionRange } from "@testing-library/user-event/dist/utils";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import { dateFormate } from "../../../utils/columns";
import { toast } from "react-toastify";
import useContextService from "hooks/useContextService";
import { cloneDeep } from "lodash";
import Loader from "components/Loader";
import Tooltip from "react-tooltip-lite";
import Question from 'assets/icon/icons8-question-mark.svg'
import { ModuleAccess } from "utils/moduleaccess";

let rowForEdit = {};
let updatedFields = {};

let hasDatePopupOpen = false;

const OrderingTab = (props) => {

  const {
    states: { configOrderingType },
    setStates,
  } = useContextService();
  const { search,
    
 } = configOrderingType;
  let Reviewpharmaforce = [
    {
      "id": "Y",
      "label": "YES"
    },
    {
      "id": "N",
      "label": "NO"
    }
  ]
  var minDate;
  const today = new Date();
  const tomorrow = new Date(today);
  minDate = { tomorrow }


  const API = useAxios();
  const { rowData, SelectedAccumulatorOrder,setLoading,keyname,
    loading, orgId,key} = props;
    

  const [tableData, setTableData] = useState([]);
  const [data, setData] = useState([]);
  const [totalrecords, setTotalReocrds] = useState([])


  const [modal, setModal] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [wholesaler, setWholeSalar] = useState([]);
  const [SelectWhosaler, setSelectWhosaler] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [Act, setAct] = useState("");
  const [gpoAct, SetGpoAct] = useState("");
  const [wacAct, SetWacAct] = useState("");
  const [review, SetReview] = useState("");
  const [poprefix, setpoPrefix] = useState("");
  const [startDate, SetStartDate] = useState("");
  const [email, setEmail] = useState("");
  const [selectedWhosaler, setSelectedWhosaler] = useState("");
  const [selectedWhosalererror, setSelectedWhosalerError] = useState("");
  const [hasTouched, setTouched] = useState('');
  const [hospitalNameError, SetHospitalNameError] = useState("");
  const [ActError, setActError] = useState("");
  const [gpoActError, setGpoActError] = useState("");
  const [wacActError, setWacActError] = useState("");
  const [reviewError, setReviewError] = useState("");
  const [poprefixError, setpoprefixError] = useState("");
  const [dateerror, setDateError] = useState("");
  const [emailerror, setEmailError] = useState("");
  const [newData, setNewData] = useState('')
  const [errorMessage, setErrorMessage] = useState('');
  const [buttonClicked, setButtonClicked] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);

  const toggle = () => {
    setModal(!modal);
  }

  let initialStates = {
    currentPage: 1,
    pageSize: 10,
    order: "",
    orderBy: "",
    Filters: [],
    AccumulatorID: SelectedAccumulatorOrder
  }

  useEffect(() => {
    handelWholesalar();
  }, [key]);

  const handelWholesalar = async () => {
    setLoading(true);
    try {
      const { data } = await API.get(`SBConfig/TypeStatus/WholesalerTypes`, {
        hasDefaultURL: true,
      });

      if (data) {
        setWholeSalar(data);
        // if (formattedOptions.length == 1) {
        //     setSelectedOption(formattedOptions[0]);
        // }
        // else{
        // }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      //. console.log(error.Message);
    }
  };

  const cellRenderEdit = (rowData) => {
    if (rowData.isEdit) {
      return (
        <div className="d-flex align-items-center">
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={savePanelUpdateRow}
            disabled={buttonClicked}
            title="Save"
          >
            <HoverImage
              key="SaveIcon"
              src={SaveIcon}
              hoverSrc={SaveHoverIcon}
              alt=""
            />
          </Button>
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => editRow(rowData, false)}
            title="Cancel"
          >
            <HoverImage
              key="CancelIcon"
              src={CancleIcon}
              hoverSrc={CancleHoverIcon}
              alt=""
            />
          </Button>
        </div>
      );
    } else {
      return (
        <div className="d-flex align-items-center">
          {renderEditLButton1(rowData)}
        </div>
      );
    }
  };
  const editRow = (rowData, isEdit = true) => {

    let tempData = [...tableData];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.wholesalerAccountID === rowData?.wholesalerAccountID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    setTouched('');
    // setSelectedStatus('');
    updatedFields = {};
    //  tableDataBackup = tempData;
    setData(tempData);
    setButtonClicked(false);
  };

  useEffect(() => {

    if (rowData) {
      handelOrdering();
    }
  }, [rowData,keyname]);


  const handelSelectWholeSaler = (e) => {
    const { value } = e.target;
    setSelectedWhosaler(value);

    if (value.length > 0) {
      setSelectedWhosalerError("")
    }
  };


  const handelOrdering = async (filterObj) => {
    if(keyname==="ordering"){
    setLoading(true);
    debugger
    if (filterObj != undefined) {
      initialStates.Filters = filterObj.filters
      initialStates.order = filterObj.order ? filterObj.order : initialStates.order
      initialStates.orderBy = filterObj.orderBy ? filterObj.orderBy : initialStates.orderBy
      initialStates.currentPage = filterObj.currentPage ? filterObj.currentPage : initialStates.currentPage
      filterObj.AccumulatorID = filterObj.AccumulatorID ? filterObj.AccumulatorID : initialStates.AccumulatorID
    }
    if (filterObj == undefined) {
      filterObj = initialStates
    }
    try {
      const { data } = await API.post(
        'SBConfig/Configuration/list', filterObj,
        {
          hasDefaultURL: true,
        });
      if (data?.items?.length > 0) {
        setTableData(data.items);
        setTotalReocrds(data.totalRecords)
        setLoading(false);
      }
      else{
        setTableData([]);
        setTotalReocrds(0);
        setLoading(false);
      }
      
    } catch (error) {
      setLoading(false);
    }
    setLoading(false);
  }
  };

  const handelNameChange = (e) => {
    const { value } = e.target;
    if (value.length > 0) {
      SetHospitalNameError("");
    }
    setHospitalName(value);
  };

  const handelActChange = (e) => {
    const { value } = e.target;
    setAct(value);

    if (value === "") {
      setActError(null)
      return;
    }

    let isValid;

    if (selectedWhosaler == 1) {
      isValid = /^\d{10}$/.test(value);
      setActError(isValid ? null : "Enter 10 digit Account code");
    } else if (selectedWhosaler == 7) {
      isValid = /^\d{5}$/.test(value);
      setActError(isValid ? null : "Enter 5 digit Account code");
    }
    else if (selectedWhosaler == 2) {
      isValid = /^\d{6}$/.test(value);
      setActError(isValid ? null : "Enter 6 digit Account code");
    }
    else if (selectedWhosaler == 17) {
      isValid = /^\d{8,10}$/.test(value);
      setActError(isValid ? null : "Enter a valid 8-10 digit Acct #");
    }
    else if (selectedWhosaler == 3) {
      isValid = /^\d{9}$/.test(value);
      setActError(isValid ? null : "Enter 9 digit Account code");
    }
    else {
      // isValid = /^\d{6}$/.test(value);
      // setActError(isValid ? null : "Enter 62 digit Account code");
      setActError("")
    }

  };

  const handelGpoAct = (e) => {
    const { value } = e.target;
    SetGpoAct(value);

    if (value === "") {
      setGpoActError(null)
      return;
    }

    let isValid;
    if (selectedWhosaler == 1) {
      isValid = /^\d{10}$/.test(value);
      setGpoActError(isValid ? null : "Enter 10 digit Account code");
    } else if (selectedWhosaler == 7) {
      isValid = /^\d{5}$/.test(value);
      setGpoActError(isValid ? null : "Enter 5 digit Account code");
    }
    else if (selectedWhosaler == 2) {
      isValid = /^\d{6}$/.test(value);
      setGpoActError(isValid ? null : "Enter 6 digit Account code");
    }
    else if (selectedWhosaler == 17) {
      isValid = /^\d{8,10}$/.test(value);
      setGpoActError(isValid ? null : "Enter a valid 8-10 digit Acct #");
    }
    else if (selectedWhosaler == 3) {
      isValid = /^\d{9}$/.test(value);
      setGpoActError(isValid ? null : "Enter 9 digit Account code");
    }
    else {
      // isValid = /^\d{6}$/.test(value);
      // setGpoActError(isValid ? null : "Enter 62 digit Account code");
      setGpoActError("")
    }
  };

  const handelWacAct = (e) => {
    const { value } = e.target;
    SetWacAct(value);

    if (value === "") {
      setWacActError(null)
      return;
    }

    let isValid;

    if (selectedWhosaler == 1) {
      isValid = /^\d{10}$/.test(value);
      setWacActError(isValid ? null : "Enter 10 digit Account code");
    }
    else if (selectedWhosaler == 7) {
      isValid = /^\d{5}$/.test(value);
      setWacActError(isValid ? null : "Enter 5 digit Account code");
    }
    else if (selectedWhosaler == 2) {
      isValid = /^\d{6}$/.test(value);
      setWacActError(isValid ? null : "Enter 6 digit Account code");
    }
    else if (selectedWhosaler == 17) {
      isValid = /^\d{8,10}$/.test(value);
      setWacActError(isValid ? null : "Enter a valid 8-10 digit Acct #")
    }
    else if (selectedWhosaler == 3) {
      isValid = /^\d{9}$/.test(value);
      setWacActError(isValid ? null : "Enter 9 digit Account code");
    }
    else {
      setWacActError("")
    }
  };


  const handelReviewChange = (e) => {
    const isChecked = e.target.checked;
    SetReview(isChecked);
    if (isChecked) {
      setReviewError("");
    }
  };


  const handelPoPrefix = (e) => {

    const isChecked = e.target.checked;
    setpoPrefix(isChecked);
    if (isChecked) {
      setpoprefixError("");
    }
  };

  const handelStartDate = (startDate) => {

    // const {value}=e.target
    let adddate = startDate;
    if (adddate) {
      setDateError("");
    }
    SetStartDate(adddate);
  };
  const handelEmailChange = (e) => {

    const { value } = e.target;
    if (value.length > 0) {
      setEmailError("");
    }
    setEmail(value);
  };
    const hasPermission = (code) => {
      return ModuleAccess("CON", code);
  }
  const renderEditLButton1 = (rowData) => {
    if (hasPermission('ED'))
    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        onClick={() => editRow(rowData)}
        title="Edit"
      >
        <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
      </Button>
    );
  };
  const handleFilterCancel = (filterObj) => {
    setColumnFilters([]);
    handelOrdering(filterObj);
  };
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };
  const updateRowValue = (value, col) => {
    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
  };
  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    if (formatterType == "statusList") {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          alwaysEditableCheckbox={alwaysEditableCheckbox}
          listArray={Reviewpharmaforce}
        />
      );
    }
    else {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          alwaysEditableCheckbox={alwaysEditableCheckbox}
        />
      );
    }
  };
  const checkvalidation = (selectedvaluesonly) => {
    debugger;
    if (selectedvaluesonly.pfReviewFlag == null || selectedvaluesonly.pfReviewFlag == undefined || selectedvaluesonly.pfReviewFlag == "") {
      toast.error('Please Select Review in PharmaForce');
      return true;
    }

    else if ((selectedvaluesonly.suppressPOPrefix == undefined || selectedvaluesonly.suppressPOPrefix == null || selectedvaluesonly.suppressPOPrefix == "")) {
      toast.error('Please Select Suppress PO Prefix');
      return true;

    }
    else if ((selectedvaluesonly.orderemail == undefined || selectedvaluesonly.orderemail == null || selectedvaluesonly.orderemail == "")) {
      toast.error('Please Enter Email');
      return true;

    }
    // else if ((selectedvaluesonly.inactiveFlag == undefined || selectedvaluesonly.inactiveFlag == null || selectedvaluesonly.inactiveFlag == "")) {
    //     toast.error('Active  is requied');
    //     return true;
    // }
    else {
      return false;
    }

  }
  const checkvalidation2 = (selectedWhosalervalue) => {

    let isValid = true;

    const validateField = (value, pattern, setError, errorMessage) => {
      if (!pattern.test(value)) {
        setError(errorMessage);
        isValid = false;
      } else {
        setError(null);
      }
    };

    switch (selectedWhosalervalue) {
      case "1":
        validateField(Act, /^\d{10}$/, setActError, "Enter 10 digit Account code");
        validateField(gpoAct, /^\d{10}$/, setGpoActError, "Enter 10 digit Account code");
        validateField(wacAct, /^\d{10}$/, setWacActError, "Enter 10 digit Account code");
        break;
      case "3":
        validateField(Act, /^\d{9}$/, setActError, "Enter 9 digit Account code");
        validateField(gpoAct, /^\d{9}$/, setGpoActError, "Enter 9 digit Account code");
        validateField(wacAct, /^\d{9}$/, setWacActError, "Enter 9 digit Account code");
        break;
      case "2":
        validateField(Act, /^\d{6}$/, setActError, "Enter 6 digit Account code");
        validateField(gpoAct, /^\d{6}$/, setGpoActError, "Enter 6 digit Account code");
        validateField(wacAct, /^\d{6}$/, setWacActError, "Enter 6 digit Account code");
        break;
      case "7":
        validateField(Act, /^\d{5}$/, setActError, "Enter 5 digit Account code");
        validateField(gpoAct, /^\d{5}$/, setGpoActError, "Enter 5 digit Account code");
        validateField(wacAct, /^\d{5}$/, setWacActError, "Enter 5 digit Account code");
        break;
      case "17":
        validateField(Act, /^\d{8,10}$/, setActError, "Enter a valid 8-10 digit Acct #");
        validateField(gpoAct, /^\d{8,10}$/, setGpoActError, "Enter a valid 8-10 digit Acct #");
        validateField(wacAct, /^\d{8,10}$/, setWacActError, "Enter a valid 8-10 digit Acct #");
        break;
      default:
        isValid = true;
    }
    return isValid;
  };
  const savePanelUpdateRow = async () => {

    setButtonClicked(true);
    if (checkvalidation(rowForEdit)) {
      setButtonClicked(false);
      return true;
    }

    setLoading(true);

    const payload = { ...rowForEdit };
    delete payload.isEdit;

    try {
      setLoading(true)
      const result = await API.post(
        `SBConfig/Configuration/EditWHAccountDetails`,
        payload,
        {
          hasDefaultURL: true,
        },
      );

      if (result) {

        if (result.data.error) {
          toast.error(result.data.message);
          setButtonClicked(false);
        }
        else {
          toast.success('Ordering Updated Successfully');
        }
        handelOrdering();
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      setButtonClicked(false);
    }
  };
  const handleSubmit = async () => {

    let Addwholesaler = [];
    let poprefixflag = "";
    let reviewflag = "";

    if (selectedWhosaler.length === 0) {
      setSelectedWhosalerError("Please Select Wholesaler")
    }
    if (hospitalName.length === 0) {
      SetHospitalNameError("Please Enter Hospital Name");
    }
    if (Act.length === 0) {
      setActError("Please Enter 340B Acct");
    } else if (Act === wacAct) {
      setWacActError("WAC Account Code should be unique")
    }
    if (gpoAct.length === 0) {
      setGpoActError("Please Enter GPO Acct");
    } else if (Act === gpoAct) {
      setGpoActError("GPO Account Code should be unique");
    }
    if (wacAct.length === 0) {
      setWacActError("Please Enter the WAC Acct");
    } else if (gpoAct === wacAct) {
      setWacActError("WAC Account Code should be unique")
    }
    if (startDate.length === 0) {
      setDateError("Start Date is a required field");
    }
    if (email.length === 0) {
      setEmailError("PO Drop-Off Email Notification is a required field");
    }
    if (!checkvalidation2(selectedWhosaler)) {
      return false;
    }
    if (poprefix == true) {
      poprefixflag = "Y";
    }
    if (poprefix == false) {
      poprefixflag = "N";
    }
    if (review == true) {
      reviewflag = "Y";
    }
    if (review == false) {
      reviewflag = "N";
    }
    if (Act === wacAct || Act === gpoAct || gpoAct === wacAct) {
      return;
    }
    else {
      setActError("");
      setGpoActError("");
      setWacActError("");
    }

    var lst = {};
    lst.AccumulatorID = SelectedAccumulatorOrder.value,
      lst.WholesalerId = selectedWhosaler,
      lst.WholesalerName = selectedWhosaler,
      //lst.WholesalerCode ="CH",
      lst.HospitalName = hospitalName,
      lst.WACAcct = wacAct,
      lst.Acct340B = Act,
      lst.GPOAcct = gpoAct,
      lst.ReviewInPharmaForce = reviewflag,
      lst.SuppressPOPrefix = poprefixflag,
      lst.StartDate = startDate,
      lst.PODropOffEmailNotification = email
    Addwholesaler.push(lst);
    setLoading(true);
    if (
      selectedWhosaler &&
      hospitalName &&
      wacAct &&
      Act &&
      gpoAct &&
      startDate &&
      email
    ) {
      setLoading(true);
      setIsSaveDisabled(true);
      try {

        const data = await API.post(
          `SBConfig/Configuration/AddWHAccountDetails`,
          { Addwholesaler },
          {
            hasDefaultURL: true,
            hideLoader: true,
          }
        );

        if (data.data[0].success === null && data.data[0].message === null) {
          toast.success("Wholesaler Added Successfully");
          handelOrdering();
          handelCancel();
        }
        else {
          toast.success("Hospital Name already exists for this wholesaler.Please create a unique Hospital Name.")
          setErrorMessage("Hospital Name already exists for this wholesaler.Please create a unique Hospital Name.")
        }
        setLoading(false);
      }
      // }
      catch (error) {
        console.log(error);
      }
      setIsSaveDisabled(false);
    }
  };
  const handelCancel = async () => {
    toggle()
    setHospitalName("")
    setAct("")
    SetWacAct("")
    SetGpoAct("")
    SetWacAct("")
    SetReview("")
    setpoPrefix("")
    setEmail("")
    setSelectedWhosaler("")
    SetStartDate("")
    SetHospitalNameError("")
    setActError("")
    setWacActError("")
    setGpoActError("")
    setSelectedWhosalerError("")
    setDateError("")
    setEmailError("")
    setErrorMessage("")
  }
  const handlePageChange = (filter, haveColFilter) => {
    debugger
    updateWholesalerSearch(filter);
    const filterObj = cloneDeep(search);
    if (haveColFilter) {
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.AccumulatorID = filter.AccumulatorID
      handelOrdering(filterObj);
    } else {
      handelOrdering(filterObj);
    }
  };

  const updateWholesalerSearch = (filter) => {
    search.currentPage= filter.currentPage;
    search.pageSize= filter.pageSize;
    search.order= filter.order;
    search.orderBy= filter.orderBy;
  }

  const [columnFilters, setColumnFilters] = useState([]);
  const handleSearchColumnFilters = async (colFilter) => {
debugger;
    const filterObj = cloneDeep(search);
    if (colFilter && colFilter.length > 0) {
      filterObj.filters = [...filterObj.filters, ...colFilter];
      setColumnFilters(colFilter);
    }
    await handelOrdering(filterObj);
  };

  // const handleSearchColumnFilters = (colFilter) => {
  //       debugger;
  //       const filterObj = cloneDeep(search);
  //       if (onSearchColumnFilters) {
  //         onSearchColumnFilters(colFilter);
  //         filterObj.filters = [...filterObj.filters, ...colFilter];
  //         setColumnFilters(colFilter);
  //       }
  //     };

  const renderStatus = (rowData, colKey) => {
    const displayText = rowData[colKey] === "Y" ? "YES" : rowData[colKey] === "N" ? "NO" : "-";
    return (
      <span className=" p-0 text-decoration-none">
        {displayText}
      </span>
    );
  };
  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 120,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "wholesalerName",
      text: "Wholesaler Name",
      sort: false,
      width: 300,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.wholesalerName),
    },
    {
      dataField: "hospitalName",
      text: "Hospital Name",
      sort: true,
      width: 300,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.hospitalName),
    },
    {
      dataField: "acct340B",
      text: "340B Acct #",
      sort: false,
      width: 120,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.acct340B),
    },
    {
      dataField: "gpoAcct",
      text: "GPO Acct #",
      sort: false,
      width: 120,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.gpoAcct),
    },
    {
      dataField: "wacAcct",
      text: "WAC Acct #",
      sort: false,
      width: 120,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.wacAcct),
    },
    {
      dataField: "pfReviewFlag",
      text: "Review In PharmaForce",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      edit: true,
      cellRenderer: (rowData, col) => rowData.isEdit == true ? formatter(rowData, col, "statusList") : renderStatus(rowData, col.dataField),
    },
    {
      dataField: "suppressPOPrefix",
      text: "Suppress PO Prefix",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      edit: true,
      cellRenderer: (rowData, col) => rowData.isEdit == true ? formatter(rowData, col, "statusList") : renderStatus(rowData, col.dataField),

    },
    {
      dataField: "startDate",
      text: "Start Date",
      sort: true,
      width: 120,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row) => dateFormate(row.startDate),
    },
    {
      dataField: "endDate",
      text: "End Date",
      sort: true,
      width: 120,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row) => dateFormate(row.endDate),
    },
    {
      dataField: "orderemail",
      text: "PO Drop-Off Email Notification",
      sort: true,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      edit: true,
      cellRenderer: (rowData, col) => formatter(rowData, col, "text"),
    },
    {
      dataField: "comments",
      text: "Comments",
      sort: true,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      edit : true,
      cellRenderer: (rowData, col) => rowData.editAbcFlag == "ABC_Flag" && rowData.isEdit == true ? formatter(rowData, col, "text") : rowData.comments,
    },
    {
      dataField: "centralReplenishment",
      text: "Central Replenishment",
      sort: false,
      width: 150,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.centralReplenishment),
    },
    {
      dataField: "centralReplenishmentHospital",
      text: "Central Replenishment Hospital",
      sort: false,
      width: 150,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.centralReplenishmentHospital),
    }
  ];
  const handleExport = async () => {
                debugger;
                const filterObj = cloneDeep(search);
                filterObj.AccumulatorID= SelectedAccumulatorOrder;
                //filterObj.ActiveButton = ActiveButton
                if (columnFilters && columnFilters.length > 0) {
                  filterObj.filters = [...filterObj.filters, ...columnFilters];
                }
            
                const { access_token } =
                  JSON.parse(localStorage.getItem('pharmaforce')) || {};
            
                  var additionalCriteria = {};
                  additionalCriteria.IsSelectedColumn = false;
                  additionalCriteria.OrgId = orgId.organizationID;
                   // additionalCriteria.ContractId = 0;
                // additionalCriteria.POId = 0;
                // additionalCriteria.OpaId = 0;
                // additionalCriteria.CEId = 0;
                // additionalCriteria.ManufactureId = 0;
            
                var payload = {};
                payload.AccumulatorID=SelectedAccumulatorOrder;
                payload.tenantID = orgId.tenantID;
                payload.gridCode = "wholesalerList";
                payload.fileTypeCode = "csv";
                payload.criteria = JSON.stringify(filterObj);
                payload.additionalCriteria = JSON.stringify(additionalCriteria);
                const { data } = await API.post(`export/queue`, payload, {
                  hasExport: true,
                });
              //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
              //  onExport(action, initialFilters);
              };
  return (
    <div>
      <div>
        <Row sm={5} style={{ justifyContent: "flex-end" }}>
          {/* <Col md="auto" className="">
            <Label>{""}</Label>

            <Button
              color="primary"
              className="ms-3"
              hidden={!(hasPermission('AD'))}
              onClick={toggle}
             // hidden={true}
            >
              Add
            </Button>
          </Col> */}
        </Row>

        <div
          className="table-card scroll-table position-relative border-0 rounded pt-2"
          fixed-height={tableData.length > 0 ? "fixed-height" : "default"}
        >
          <ReactStrapTable
            id="orderingTab-table"
            height={550}
            fixedColumn
            width={1200}
            // loading={loading}
            // reset={reset}
            // hasPagination
            data={tableData}
            columns={mainCol}
             onExport={handleExport}
            filters={initialStates}
            totalRecords={totalrecords}
            pageSize={initialStates.pageSize}
            currentPage={initialStates.currentPage}
            handleSort={handlePageChange}
            onSearchColumnFilters={handleSearchColumnFilters}
            onFilterCancel={handleFilterCancel}
            display={true}
          />
        </div>
      </div>
      <Modal isOpen={modal} fade={false} toggle={toggle} className={props.className} >
        {/* {loading && <Loader opacity={0.02} color="black" />} */}
        <ModalHeader toggle={toggle} onClick={handelCancel}>
          <h5 className="f-15 text-primary font-weight-700 mt-2">
            Add Wholesaler Account
          </h5>
        </ModalHeader>
        <ModalBody>
          <Formik
            // initialValues={initialValues}
            onSubmit={handleSubmit}
            // validationSchema={validationSchema}
            // enableReinitialize={true}
            children={(props) => {
              const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched, } = props;
              return (
                <div hidden={""}>
                  <Row sm={5}>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="Wholesaler">Wholesaler </Label>

                        <Field
                          className="required"
                          id="wholesaler"
                          name="wholesaler"
                          type="select"
                          // type="text"
                          placeholder="Select Location "
                          autoComplete="off"
                          options={wholesaler}
                          value={selectedWhosaler}
                          component={FormikSelectField}
                          // onKeyUp={handleStateData}
                          defaultoption="--Select--"
                          keys={{
                            id: "wholesalerId",
                            label: "wholesalerName",
                          }}
                          onChange={(e) => handelSelectWholeSaler(e)}
                        />
                        {selectedWhosalererror ? (
                          <div className="text-danger f-12">
                            {selectedWhosalererror}
                          </div>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="hospitalname">Hospital Name</Label>
                        <div className="d-flex">
                          <Input
                            className="required"
                            id="hospitalname"
                            name="hospitalname"
                            type="text"
                            placeholder="Enter Hospital Name"
                            autoComplete="off"
                            value={hospitalName}
                            component={""}
                            onChange={(e) => {
                              handelNameChange(e);
                            }}
                          />
                          <div style={{ marginTop: 5, marginLeft: 10 }}>
                            <Tooltip
                              content={
                                <div className="tip-list-info">
                                  <p>
                                    <strong>
                                      Hospital Name:{" "}
                                    </strong>
                                    <span>
                                      Informational purposes only. Hospital Name must
                                      be unique per Wholesaler and a max of 100
                                      characters.    </span>
                                  </p>
                                </div>
                              }
                              direction="right"
                              tagName="span"
                              className="target"
                              tipContentClassName=""
                              zIndex={99999}
                            >
                              <span className="cursor-pointer text-decoration-underline">
                                <HoverImage
                                  src={Question}
                                  hoverSrc={Question}
                                  style={{ width: '20px', height: '20px' }}
                                ></HoverImage>
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                        {hospitalNameError ? (
                          <div className="text-danger f-12">
                            {hospitalNameError}
                          </div>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="340Bacct">340B Acct #</Label>
                        <Input
                          id="340Bacct"
                          className="required"
                          name="340Bacct"
                          type="text"
                          placeholder="Enter 340Bacct"
                          autoComplete="off"
                          value={Act}
                          maxLength={15}
                          component={""}
                          onChange={(e) => {
                            handelActChange(e);
                          }}
                        />
                        {ActError ? (
                          <div className="text-danger f-12">{ActError}</div>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="GPOacct">GPO Acct #</Label>
                        <Input
                          id="GPOacct"
                          className="required"
                          name="GPOacct"
                          type="text"
                          placeholder="Enter GPO Acct #"
                          autoComplete="off"
                          value={gpoAct}
                          maxLength={15}
                          component={""}
                          onChange={() => handelGpoAct(event)}
                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                        />
                        {gpoActError ? (
                          <div className="text-danger f-12">{gpoActError}</div>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="WACacct">WAC Acct #</Label>
                        <Input
                          id="WACacct"
                          className="required"
                          name="WACacct"
                          type="text"
                          placeholder="Enter WAC Acct #"
                          autoComplete="off"
                          value={wacAct}
                          maxLength={15}
                          component={""}
                          onChange={() => handelWacAct(event)}
                        />
                        {wacActError ? (
                          <div className="text-danger f-12">{wacActError}</div>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <div className="d-flex">
                          <Label for="review">Review In PharmaForce</Label>
                          <Input
                            id="review"
                            name="review"
                            type="checkbox"
                            style={{
                              marginLeft: "22px",
                              border: "1px solid black",
                            }}
                            autoComplete="off"
                            checked={review}
                            onChange={handelReviewChange}
                          />
                          {"    "}
                          {/* <span>     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}</span> */}
                          <div style={{ marginLeft: 261 }}>
                            <Tooltip
                              content={
                                <div className="tip-list-info">
                                  <p>
                                    <strong>
                                      Review In PharmaForce:{" "}
                                    </strong>
                                    <span>
                                      This configuration allows for the customer to
                                      review the 340B, GPO and WAC split, where
                                      applicable, and approve or cancel the Purchase
                                      Order to be placed to the wholesaler for
                                      fulfillment. If this configuration is not
                                      checked, then the system will automatically upon
                                      receiving a Purchase Order to be placed to the
                                      wholesaler directly for fulfillment.    </span>
                                  </p>
                                </div>
                              }
                              direction="right"
                              tagName="span"
                              className="target"
                              tipContentClassName=""
                              zIndex={99999}
                            >
                              <span className="cursor-pointer text-decoration-underline">
                                <HoverImage
                                  src={Question}
                                  hoverSrc={Question}
                                  style={{ width: '20px', height: '20px' }}
                                ></HoverImage>
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                        {/* </div> */}
                      </FormGroup>
                    </Col>

                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <div className="d-flex">
                          <Label for="suppresspo">Suppress PO Prefix</Label>

                          <Input
                            id="suppresspo"
                            name="suppresspo"
                            type="checkbox"
                            style={{
                              marginLeft: "47px",
                              border: "1px solid black",
                            }}
                            // placeholder="Enter Review in PharmaForce"
                            autoComplete="off"
                            //value={poprefix}
                            checked={poprefix}
                            component={""}
                            onChange={(e) => {
                              handelPoPrefix(e);
                            }}
                          />
                          <div style={{ marginLeft: 263 }}>
                            <Tooltip
                              content={
                                <div className="tip-list-info">
                                  <p>
                                    <strong>
                                      Suppress PO Prefix : {" "}
                                    </strong>
                                    <span>
                                      The system automatically creates a unique
                                      numeric value with an underscore as a PO Prefix.
                                      If for any reason, the CE needs to pass the
                                      exact PO # that is imported into the system, by
                                      checking this box, the prefix will be
                                      suppressed.{" "}</span>
                                  </p>
                                </div>
                              }
                              direction="right"
                              tagName="span"
                              className="target"
                              tipContentClassName=""
                              zIndex={99999}
                            >
                              <span className="cursor-pointer text-decoration-underline">
                                <HoverImage
                                  src={Question}
                                  hoverSrc={Question}
                                  style={{ width: '20px', height: '20px' }}
                                ></HoverImage>
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="startDate">Start Date </Label>
                        <div className="d-flex">
                          <InputGroup onMouseLeave={handleMouseLeave}>
                            <Field
                              type="date"
                              required
                              id="startDate"
                              name="startDate"
                              autoComplete="off"
                              placeholder="Select a date"
                              value={startDate || ""}
                              minDate={tomorrow.setDate(today.getDate() + 1)}
                              component={FormikDatePicker}
                              onChange={handelStartDate}
                            />
                            <InputGroupText
                              onClick={() => handleDateClick("startDate")}
                            >
                              <img src={Calendar} alt="" />
                            </InputGroupText>
                          </InputGroup>
                          <div style={{ marginTop: 5, marginLeft: 10 }}>
                            <Tooltip
                              content={
                                <div className="tip-list-info">
                                  <p>
                                    <strong>
                                      Start Date : {" "}
                                    </strong>
                                    <span>
                                      Date all EDI will be processed in the system.</span>
                                  </p>
                                </div>
                              }
                              direction="right"
                              tagName="span"
                              className="target"
                              tipContentClassName=""
                              zIndex={99999}
                            >
                              <span className="cursor-pointer text-decoration-underline">
                                <HoverImage
                                  src={Question}
                                  hoverSrc={Question}
                                  style={{ width: '20px', height: '20px' }}
                                ></HoverImage>
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                        {dateerror ? (
                          <div className="text-danger f-12">{dateerror}</div>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="podroop">
                          PO Drop-Off Email Notification
                        </Label>
                        <div className="d-flex">
                          <Input
                            id="podroop"
                            className="required"
                            name="podroop"
                            type="text"
                            placeholder="Enter PO Drop-Off Email Notification"
                            autoComplete="off"
                            value={email}
                            component={""}
                            onChange={(e) => {
                              handelEmailChange(e);
                            }}
                          />
                          <div style={{ marginTop: 5, marginLeft: 10 }}>
                            <Tooltip
                              content={
                                <div className="tip-list-info">
                                  <p>
                                    <strong>
                                      PO Drop-off Email Notification :{" "}
                                    </strong>
                                    <span>
                                      The system will accept multiple email addresses
                                      by using a comma before adding additional email
                                      addresses. This is used for items on a purchase
                                      order that are not found in the wholesaler
                                      catalog. Upon receiving this email the customer
                                      can directly submit this item</span>
                                  </p>
                                </div>
                              }
                              direction="right"
                              tagName="span"
                              className="target"
                              tipContentClassName=""
                              zIndex={99999}
                            >
                              <span className="cursor-pointer text-decoration-underline">
                                <HoverImage
                                  src={Question}
                                  hoverSrc={Question}
                                  style={{ width: '20px', height: '20px' }}
                                ></HoverImage>
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                        {emailerror ? (
                          <div className="text-danger f-12">{emailerror}</div>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col
                      md={2}
                      lg={2}
                      sm={2}
                      xs={2}
                      className="d-flex justifycontent-center"
                    >
                      {" "}
                      <FormGroup className="align-self-center"></FormGroup>
                    </Col>
                  </Row>
                </div>
              );
            }}
          ></Formik>
        </ModalBody>
        <ModalFooter>
          {errorMessage ? (
            <div style={{ marginRight: "220px", backgroundColor: "#ffe6e6" }} className="text-danger f-12">{errorMessage}</div>
          ) : null}
          <Button color="primary" onClick={handleSubmit} disabled={isSaveDisabled}>
            Save
          </Button>{" "}
          <Button
            color="primary"
            onClick={handelCancel}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default OrderingTab;
